import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Reconocimientos from "@/components/Reconocimientos";
import Ejes from "@/components/Ejes";
import Mapa from "@/components/Mapa";
import Propuestas from "@/components/Propuestas";
import FactChecking from "@/components/FactChecking";
import Footer from "@/components/Footer";
import { useSiteConfig } from "@/hooks/useSiteConfig";

export default function Portal() {
  const config = useSiteConfig();
  const [query, setQuery] = useState("");
  const [selectedFact, setSelectedFact] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const goToFact = useCallback((fact) => {
    setSelectedFact(fact);
    requestAnimationFrame(() => {
      document.getElementById("fact-checking")?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  return (
    <div className="min-h-screen bg-arena-sand">
      <Navbar config={config} />
      <main>
        <Hero config={config} onSelectFact={goToFact} />
        <Marquee />
        <Reconocimientos config={config} />
        <Ejes />
        <Mapa />
        <FactChecking
          config={config}
          query={query}
          setQuery={setQuery}
          selected={selectedFact}
          onSelect={setSelectedFact}
        />
        <Propuestas config={config} />
      </main>
      <Marquee light />
      <Footer config={config} />
    </div>
  );
}
